exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-gray[data-v-3294723e] {\n  -webkit-filter: contrast(0.3);\n          filter: contrast(0.3);\n}\n", ""]);

// exports
